// const BASE_URL ='http://172.16.45.64:9090';//公司
// const BASE_URL = 'http://172.16.54.46:9090';
// const BASE_URL = "http://192.168.10.62:9090"; //测试用
// const BASE_URL = "http://192.168.10.91:9090"; //20221228后测试用
// const BASE_URL = "http://218.77.45.25:8019"; //李顺清测试
// const BASE_URL ='http://172.16.42.179:9090'; //长沙调试
const BASE_URL ='http://tfw.changshabdc.com'; //长沙调试

// 注释 BASE_URL打开上面某一条
import axios from 'axios';
// const BASE_URL = "";
export { BASE_URL };
//发布房源
export const TESTING_URL = BASE_URL + "/mobile/houseX/ValidHousing"; //验证房源
export const GET_HOUSINGSET = BASE_URL + "/mobile/housex/GetHousingSet"; //下拉选项
export const SET_HOUSEMSG1 = BASE_URL + "/mobile/housex/SaveRoomInfo"; //保存房源信息1
export const SET_HOUSEMSG2 = BASE_URL + "/mobile/housex/SaveRoomIssue"; //保存房源信息2
export const UPLOAD_IMG = BASE_URL + "/mobile/housex/UploadImg"; //上传图片
export const GET_IMGLIST = BASE_URL + "/mobile/housex/GetImgOfIssue"; //获取图片列表
export const DEL_IMG = BASE_URL + "/mobile/housex/DelImg"; //删除图片
export const SAVE_MSG = BASE_URL + "/mobile/housex/SaveRoomIssue"; //保存信息
export const SUBMIT_MSG = BASE_URL + "/mobile/housex/SubmitApproval"; //提交审核

// 消息模块
export const GET_MESSAGELIST = BASE_URL + "/mobile/usercenter/getMessageList"; //获取消息列表
export const GET_MESSAGEMODEL = BASE_URL + "/mobile/usercenter/getMessageModel"; //获取消息详情
export const GET_DELMESSAGE = BASE_URL + "/mobile/usercenter/DelMessage"; //删除消息

//二手房模块
export const GET_INDEXSET = BASE_URL + "/mobile/QueryConfig/GetIndexSet"; //列表查询选项

export const GET_CLICK = BASE_URL + "/mobile/housex/click"; //点击量
export const GET_HOTHOUSELIST = BASE_URL + "/mobile/housex/getHotHouseList"; //获取热门房源列表
export const GET_HOUSELIST = BASE_URL + "/mobile/HouseX/getHouseList"; //获取房源列表
export const GET_ISSUEINFO = BASE_URL + "/mobile/HouseX/GetIssueInfo"; //获取房源详情
export const GET_VERIFYHOUSESMS = BASE_URL + "/mobile/housex/VerifyHouseSms"; //房源状态验证码
export const GET_HOUSESTATE = BASE_URL + "/mobile/housex/GetHouseState"; //获取房源状态
export const GET_TLPMSG = BASE_URL + "/mobile/housex/getStateSms"; //获取短信验证码

// 产权核验
export const POST_ESTATE = BASE_URL + "/mobile/Verification/Estate"; //买家保存信息

export const GET_NEARBYHOUSING = BASE_URL + "/mobile/map/GetNearbyHousing"; //获取附近房源
export const GET_JJR = BASE_URL + "/mobile/HouseX/GetJJR"; //获取联系人信息
export const GET_SIGNAPPLY = BASE_URL + "/mobile/HouseSign/SignApply"; //在线签约提交申请
export const GET_COLLECTHOUSE = BASE_URL + "/mobile/housex/CollectHouse"; //收藏房源
export const GET_SIGNLIST = BASE_URL + "/mobile/housesign/signlist"; //获取签约列表
export const GET_SIGN_LIST = BASE_URL + "/mobile/netsign/signlist"; //获取签约列表

export const GET_HOUSE_BROWSE = BASE_URL + "/mobile/housex/getHouseBrowse"; //房源浏览记录

export const GET_SIGNHOUSEINFO =
  BASE_URL + "/mobile/housesign/GetSignHouseInfo"; //获取签约详情
export const POST_SIGNAPPLYAPP = BASE_URL + "/mobile/HouseSign/SignApplyApp"; //卖方处理签约
export const POST_SAVEPAYMENT = BASE_URL + "/mobile/housesign/SavePayment"; //买家提交付款信息
export const POST_SAVEBUYERSUPERVISE =
  BASE_URL + "/mobile/housesign/SaveBuyerSupervise"; //买家退款信息
export const POST_SAVEBUYERLIST = BASE_URL + "/mobile/housesign/SaveBuyerList"; //买家保存信息

export const GET_ROOMLIST = BASE_URL + "/mobile/map/getroomlist"; //获取地图房源列表
export const GET_GROUPSAREA = BASE_URL + "/mobile/map/GetGroupsArea"; //获取地图区域板块
export const GET_COMMUNITY = BASE_URL + "/mobile/map/GetCommunity"; //获取地图小区

// 预约看房
export const POST_BESPEAK = BASE_URL + "/mobile/HouseSign/Bespeak"; //预约看房
export const GET_BESPEAKLIST = BASE_URL + "/mobile/housesign/BespeakList"; //预约列表

// 我需要房
export const GET_HOPE_HOUSELIST = BASE_URL + "/mobile/housesign/HopeHouseList"; //帖子列表
export const GET_HOPE_MYHOUSELIST =
  BASE_URL + "/mobile/housesign/MyHopeHouseList"; //我的帖子
export const DELETE_HOPE_HOUSE = BASE_URL + "/mobile/housesign/DeleteHopeHouse"; //删除帖子
export const GET_HOPE_HOUSEDETAIL =
  BASE_URL + "/mobile/housesign/HopeHouseDetail"; //帖子详情
export const POST_HOPE_HOUSEDEMAND =
  BASE_URL + "/mobile/housesign/HopeHouseDemand"; //发帖

//注册登录模块
export const TLP_REGISTER = BASE_URL + "/mobile/account/RegisterStep1"; //注册
export const WECHAT_REGISTER = BASE_URL + "/mobile/account/WeChatRegister"; //微信注册

export const TLP_LOGIN = BASE_URL + "/mobile/account/PortalLogin"; //登录
export const GET_WECHAT_SMSCODE = BASE_URL + "/mobile/account/GetWeChatSmsCode"; //微信绑定获取验证码

//WX认证
export const APPROVE_CARD_POSITIVE =
  BASE_URL + "/mobile/face/identifyCardFront"; //证件正面识别
export const APPROVE_CARD_NEGATIVE = BASE_URL + "/mobile/face/identifyCardBack"; //证件反面识别
export const GET_SURE_NAME = BASE_URL + "/mobile/face/getWeChatUserKey"; //获取实名凭证
export const GET_SURE_NAME2 = BASE_URL + "/mobile/face/getWeChatUserKeyForZX"; //获取实名凭证(账号注销时未实名用户使用)

export const GET_JSSDK_CONFIG = BASE_URL + "/mobile/face/getJsSdkConfig"; //获取jssdk
export const VERIFY_CARD_FACE = BASE_URL + "/mobile/face/VerifyCardFace"; //验证结果

export const APPROVE_CARD = BASE_URL + "/mobile/account/RegisterStep2"; //证件检测
export const VERIFY_CODE = BASE_URL + "/mobile/account/getH5SessionCode"; //获取语音验证码
export const VERIFY_BASE64 = BASE_URL + "/mobile/account/RegisterStep3_H5"; //活体认证

//用户中心
export const GET_MYHOUSE = BASE_URL + "/mobile/usercenter/GetMyhouse"; //发布房源
export const GET_COLLECT_LIST = BASE_URL + "/mobile/usercenter/getCollectList"; //收藏列表
export const DELETE_COLLECT = BASE_URL + "/mobile/usercenter/DelCollect"; //删除收藏
export const DEL_HOUSE = BASE_URL + "/mobile/usercenter/DelHouse"; //删除房源
export const REOVKE_HOUSE = BASE_URL + "/mobile/usercenter/RevokeHouse"; //停售
export const GET_USER_INFO = BASE_URL + "/mobile/usercenter/GetUserInfo"; //用户信息
export const USER_EXIT = BASE_URL + "/mobile/account/LogOut"; //退出
export const POST_MODIFY = BASE_URL + "/mobile/housex/getHouseEditInfo"; //修改房源
export const UPLOAD_USER_IMG = BASE_URL + "/mobile/usercenter/ModifyFace"; //上传头像

// 解绑换绑注销
export const CHECK_YW_LIMIT = BASE_URL + "/Mobile/Account/CheckYwLimit"; //校验是否有在办业务
export const USER_INFO_UNBIND = BASE_URL + "/Mobile/Account/UserInfoUnbind"; //解除绑定
export const POST_WRITE_OFF = BASE_URL + "/mobile/usercenter/WriteOff"; //人脸账号注销
export const GET_SMS_CODE = BASE_URL + "/Mobile/Account/GetSmsCode"; //获取注销验证码
export const OFF_BYPHONE_ChECK = BASE_URL + "/Mobile/Account/WriteOffByPhoneCheck"; //手机验证码注销

//预约模块
export const GET_APPLYLIST = BASE_URL + "/mobile/apply/getApplyList"; //预约列表
export const GET_SYSTEMLIST = BASE_URL + "/mobile/apply/getOutletsList"; //网点列表
export const GET_ITEMLIST = BASE_URL + "/mobile/apply/getApplyItems"; //事件列表
export const GET_DATELIST = BASE_URL + "/mobile/apply/getApplyDate"; //预约日期
export const POST_VERIFY = BASE_URL + "/mobile/apply/VerifyAppointment"; //提交预约
export const CHECK_APPOINTMENT_VERIFY = BASE_URL + "/mobile/apply/VerifySelfApply"; //提交预约
export const POST_SUBMIT = BASE_URL + "/mobile/apply/ApplySubmit"; //提交预约
export const POST_ENTERPRISE_SUBMIT =
  BASE_URL + "/mobile/apply/ApplyEnterpriseSubmit"; //企业提交预约
export const GET_DETAIL = BASE_URL + "/mobile/apply/getApplyDetail"; //预约详情
export const POST_SELECTDETAIL = BASE_URL + "/mobile/apply/QueryMyApply"; //预约查询
export const POST_CANCEL = BASE_URL + "/mobile/apply/cancelapply"; //取消预约
export const POST_VERIFYENTERPRISE =
  BASE_URL + "/mobile/apply/VerifyEnterprise"; //企业预约获取证件信息

//二维码校验
export const POST_QRCODE = BASE_URL + "/mobile/account/VCertification";
export const POST_OUTPUT_QRCODE = BASE_URL + "/api/housex/VCertification";

//进度查询
export const GET_PROGRESS_RESULT = BASE_URL + "/mobile/apply/QueryStatus";

//新闻,办事指南
export const GET_NEWSLIST = BASE_URL + "/mobile/news/getNewsList"; //column ：bszn代表办事指南,gfbk购房百科
export const GET_NEWSDETAIL = BASE_URL + "/mobile/news/getNewsDetail";

//快速网签
export const POST_PROPERTYMSG = BASE_URL + "/mobile/NetSign/Verify"; //产权认证
export const POST_BUYERINFO = BASE_URL + "/mobile/netsign/InputBuyers"; //录入买家信息
export const GET_NETSIGNDETAIL = BASE_URL + "/mobile/netsign/getNetSignDetail"; //获取签约详情
export const POST_SELLERINFO = BASE_URL + "/mobile/netsign/InputSeller"; //录入卖家信息
export const GET_CONTRACT = BASE_URL + "/mobile/netsign/PreviewContract"; //预览合同

export const GET_CARD_FORNT_OCR = BASE_URL + "/mobile/netsign/getCardFrontocr"; //身份证OCR
export const BRUSH_FACE_CONFIRM = BASE_URL + "/mobile/netsign/BrushFaceConfirm"; //买卖双方刷脸确认
export const FACE_CHECK = BASE_URL + "/mobile/netsign/FaceCheck"; //卖家刷脸确认（认证产权后）

//有问必答
export const GET_QUESTION_LIST = BASE_URL + "/mobile/infor/myquestionlist"; //我的问题列表
export const GET_ALL_QUESTION_LIST = BASE_URL + "/mobile/infor/QuestionList"; //所有问题列表

export const POST_SUBMIT_QUESTION = BASE_URL + "/mobile/infor/submitquestion"; //提交问题
export const GET_QUESTION_DETAIL = BASE_URL + "/mobile/infor/MyQuestionDetail"; //问题详情
//档案查询
export const GET_BDC_PDF = BASE_URL + "/mobile/query/BDCProvePDF"; //档案PDF
// export const POST_VERIFY_FACE = BASE_URL + '/mobile/query/VerifyFace';//提交问题
export const POST_VERIFY_FACE = BASE_URL + "/mobile/face/QueryVerifyFace"; //提交问题
export const GET_ACCESS_TOKEN = BASE_URL + "/mobile/query/getAccessToken"; //获取访问凭证
export const GET_NUCLEAR_TEST = BASE_URL + "/mobile/query/NuclearTest"; //编号核验
export const GET_QUERY_COUNT = BASE_URL + "/mobile/query/VQueryCount"; //次数校验
export const POST_VERIFY_MINOR = BASE_URL + "/mobile/query/VerifyMinor"; // 验证未成年
export const GET_MINOR_PDF = BASE_URL + "/mobile/query/getMinorPdf"; // 未成年人不动产查询
export const GET_MINOR_BDCINFOLIST = BASE_URL + "/mobile/query/MinorBdcInfoList"; //	获取产权列表
export const GET_QUERY_NUCLEAR = BASE_URL + "/mobile/query/NuclearTest"; //	2.	电子编号核验


export const GET_TEST_TOKEN = BASE_URL + "/mobile/query/testtoken"; //pdf测试

export const GET_DZZM_LIST = BASE_URL + "/mobile/query/getDZZMList"; //电子证照列表
export const Electronic_Photo_Verification = BASE_URL + "/mobile/query/DLRYZ"; //电子证照验证

export const GET_DZZM_TOKEN = BASE_URL + "/mobile/query/DZZMQueryCount"; //电子证照次数校验

export const GET_CHANGE_SMS = BASE_URL + "/mobile/usercenter/getChangeSms"; //获取新手机验证码
export const CHANGE_PHONE_NUMBER =
  BASE_URL + "/mobile/usercenter/ChangePhoneNumber"; //手机验证码变更

export const GET_OLD_SMS = BASE_URL + "/mobile/usercenter/getOldSms"; //获取旧手机验证码
export const VERIFY_OLD_SMS = BASE_URL + "/mobile/usercenter/VerifyOldSms"; //手机验证码变更下一步

export const GET_QUERY_ZL = BASE_URL + "/mobile/query/getQueryZL"; //坐落查询列表

export const GET_ZL_DETAIL = BASE_URL + "/mobile/query/getZLDetail"; //坐落查询详情

export const ParseOpenErCode = BASE_URL + "/api/Verification/ParseOpenErCode"; //验证二维码
export const OpenFace = BASE_URL + "/api/Verification/OpenFace"; //验证人脸

export const ECode = BASE_URL + "/api/Verification/ECode"; //证明二维码核验

export const GET_BDC_INFO_LIST = BASE_URL + "/mobile/query/BdcInfoList"; //获取产权列表
export const BDC_INFO_DETAIL = BASE_URL + "/mobile/query/BdcInfoDetail"; //获取产权详情

var instance = axios.create({
  headers: { "content-type": "application/json" },
});
export const ajaxPost = (data) => {
  return instance.request({
    method: "POST",
    responseType: "blob",
    data: data,
    url: BASE_URL + "/mobile/query/BdcInfoDetail"
  })
}

export const getBookingInfoQueryList = BASE_URL + "/api/Query/getBookingInfoQueryList"; //预约查询
export const getOutletsInfoList = BASE_URL + "/api/Query/getOutletsInfoList"; //下拉列表

export const POST_QKL_QLRCX = BASE_URL + "/api/Verification/QLRCX"; //权利人查询区块链数据校验
export const POST_QKL_DYQRGXCX = BASE_URL + "/api/Verification/DYQRGXCX"; //利害关系人（抵押权人关系）查询区块链数据校验
export const POST_QKL_FQGXCX = BASE_URL + "/api/Verification/FQGXCX"; //利害关系人（夫妻关系）查询区块链数据校验

export const GET_YTCF_USER_INFO = BASE_URL + "/api/UserCenter/YTCFGetUserInfo"; //进入以图查房之前先查询用户信息

// 家庭成员录入
export const GET_ELIGIABLE_INIT = BASE_URL + "/Mobile/NeedHandle/EligibleInit"; //核验初始化
export const SUBMIT_FAMILY_MEMBER = BASE_URL + "/Mobile/NeedHandle/SubmitFamilyMember"; //核验初始化
export const GET_FAMILY_MEMBER_LIST = BASE_URL + "/Mobile/NeedHandle/GetFamilyMemberList"; //获取家庭成员录入列表
export const PREVIEW_FAMILY_MEMBER = BASE_URL + "/Mobile/NeedHandle/PreviewFamilyMember"; //获取家庭成员详细信息

//证书申领
export const LOAD_CQXX_BY_USERID = BASE_URL + "/Mobile/NeedHandle/LoadCqxxByUserId"; //获取可申领证书的产权
export const GET_CHECK_GBF = BASE_URL + "/Mobile/NeedHandle/CheckGbf"; //检查是否满足工本费
export const ZSSL_CREATE_BUSSINESS = BASE_URL + "/Mobile/NeedHandle/CreateBussiness"; //创建证书申领业务
export const ZSSL_SAVE_BUSSINESS = BASE_URL + "/Mobile/NeedHandle/Save"; //保存证书申领业务
export const SURE_APPLY_MSG = BASE_URL + "/Mobile/NeedHandle/SureApplyMsg"; //共有人确认信息
export const SUM_SEND_TIME = BASE_URL + "/Mobile/NeedHandle/SumSendTime"; //获取预计邮寄时间
export const ZSSL_UPDATE_BUSINESS_STATUS = BASE_URL + "/Mobile/NeedHandle/Submit"; //更新业务状态
export const ZSSL_GET_BUSINESS = BASE_URL + "/Mobile/NeedHandle/LoadBussiness"; //获取待办业务列表
export const ZSSL_GET_BUSINESS_LIST = BASE_URL + "/Mobile/NeedHandle/LoadBussinessList"; //获取待办业务列表
export const ZSSL_DELETE_BUSINESS = BASE_URL + "/Mobile/NeedHandle/Cancle"; //删除业务

//无纸化
export const PRE_APPLY_LIST = BASE_URL + "/Mobile/NeedHandle/PreApplyList"; //加载预告权利人业务列表
export const APPLY_COMMISSION = BASE_URL + "/Mobile/NeedHandle/ApplyCommission"; //加载预告权利人问询列表
export const SUBMIT_ANSWERS = BASE_URL + "/Mobile/NeedHandle/SubmitAnswers"; //提交预告权利人问询答案
export const LOAD_SIGN_LIST = BASE_URL + "/Mobile/NeedHandle/LoadSignList"; //获取预告权利人签名列表
export const PRE_VIEW_FILE = BASE_URL + "/Mobile/NeedHandle/PreviewFile"; //预览文件
export const SEND_FACE_REQUEST = BASE_URL + "/Mobile/NeedHandle/SendFaceRequest"; //发起人脸识别
export const SEND_CA_SIGN = BASE_URL + "/Mobile/NeedHandle/SendCaSign"; //发起签名请求
export const PRE_APPLY_DLRLIST = BASE_URL + "/Mobile/NeedHandle/PreApplyDlrList"; //加载代理人确认业务列表
export const LOAD_FACE_DLRLIST = BASE_URL + "/Mobile/NeedHandle/LoadFaceDlrList"; //加载代理人确认承诺书列表
export const PRE_VIEW_WTFILE = BASE_URL + "/Mobile/NeedHandle/PreviewWtFile"; //预览委托文件


// WEBPACK FOOTER //
// ./src/constants/index.js